import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import PropTypes from 'prop-types';

import numeral from "numeral";
import moment from "moment";

import { BeatLoader } from "react-spinners";
import {
  getMarcasByVehicleType,
  getModelByVehicleType,
  getModelosById,
  getGastos,
  getPlazos,
  calculateFee,
  getTypeProducts,
  getTasaVFMG,
  getCesByCodSpider,
  getHomologation,
  getHomologatedCars,
  getBrandByModel,
  getRegistration,
  getHomologated,
} from "../../../redux/actions";
import BusinessForm from "./BusinessForm";
import { filter, find, some } from "lodash";
import {
  BUSINESS_TYPES,
  CES_CONSIDERED,
  initialInsurances,
  VEHICLE_TYPES,
  VEHICLE_TYPES_INT
} from "../../../helpers/constants";
import VehicleForm from "./VehicleForm";
import PriceInput from "./PriceInput";
import FootAndTermInput from "./FootAndTermInput";
import {
  currentChinese,
  findProductByBusinessType,
  getVehicleStatusString,
  valueIsBetween
} from "../../../helpers/functions";

const search = window.location.search; // could be '?foo=bar'
const params = new URLSearchParams(search);

class Home extends Component {
  constructor(props) {
    super(props);

    const step1 = JSON.parse(localStorage.getItem("step1")) || {};

    // Helper function to parse dates
    const parseDate = (date) => moment(new Date(date)).toISOString().substring(0, 10);

    // Initialize dates
    const fechaCurse = step1.fechaCurse ? parseDate(step1.fechaCurse) : parseDate(new Date());
    const fechaVencimiento = step1.fechaVencimiento
        ? parseDate(step1.fechaVencimiento)
        : parseDate(moment(fechaCurse).add(1, 'month'));

    // Extract and initialize vehicle details
    const vehicleDetails = {
      vehicleType: params.get("vehicleType") === VEHICLE_TYPES.MOTO || params.get("isMoto")
          ? VEHICLE_TYPES.MOTO
          : params.get("vehicleType") || step1.vehicleType || VEHICLE_TYPES.AUTO,
      businessType: params.get("businessType") || step1.businessType || "",
      isMoto: params.get("isMoto") === 'true' || params.get("vehicleType") === VEHICLE_TYPES.MOTO || step1.isMoto || false,
      isDealrs: Boolean(params.get("brand")) || step1.isDealrs || false,
      price: parseInt(params.get("price")) || step1.price || 0,
      year: params.get("year") || step1.year || "",
      model: params.get("model") || step1.model || "",
      brand: params.get("brand") || step1.brand || "",
      brandId: params.get("brand") || "",
      modelId: params.get("model") || "",
      priceClean: parseInt(params.get("price")) || step1.priceClean || 0,
      yearExists: Boolean(params.get("year")) || step1.yearExists || false,
      priceExists: Boolean(params.get("price")) || step1.priceExists || false,
    };

    // Initialize insurance details
    const insuranceDetails = {
      isGps: step1.isGps || false,
      isSegPerdidaTotal: step1.isSegPerdidaTotal || false,
      isSegDegravamen: step1.isSegDegravamen || false,
      isSegDegravamenPlus: step1.isSegDegravamenPlus || false,
      isSegCesantia: step1.isSegCesantia || false,
      isSegAutoProtegido: step1.isSegAutoProtegido || false,
      isAccesorios: step1.isAccesorios || false,
    };

    // Initialize other state variables
    const defaultState = {
      productoSelected: null,
      messagePrice: "",
      dataProducto: null,
      codProducto: "",
      dataCes: {},
      mensajeErrorService: "",
      listMarcas: [],
      listModelos: [],
      listPlazos: [
        { Plazo: 24, PlazoVigencia: true, RANGOVFMG: { Minimo: 50, Maximo: 50 } },
        { Plazo: 36, PlazoVigencia: true, RANGOVFMG: { Minimo: 50, Maximo: 50 } },
      ],
      listGatos: [],
      typeProducts: [],
      listProductos: {},
      tasaVFMG: [],
      foot: vehicleDetails.price ? Math.trunc(vehicleDetails.price * 0.2) : step1.foot || "",
      term: step1.term || "",
      shareValue: step1.shareValue || "",
      valorCae: step1.valorCae || 0,
      businessTypeName: vehicleDetails.businessType === BUSINESS_TYPES.CONVENCIONAL ? "Convencional" : "Auto Renuévate",
      vehicle: "AUTO",
      fechaCurse,
      fechaVencimiento,
      region: step1.region || "",
      mensajeFechaError: "",
      flagCalculate: step1.flagCalculate || false,
      idConcesionaria: this.props.match.params.id,
      footClean: vehicleDetails.priceClean ? Math.trunc(vehicleDetails.priceClean * 0.2) : step1.footClean || 0,
      messageFoot: "",
      productoId: "",
      vehicleStatus: step1.vehicleStatus || params.get("vehicleStatus") || 1,
      vehicleStatusNU: step1.vehicleStatus || params.get("vehicleStatus") || 1,
      loadingCalculo: false,
      search: window.location.search,
      pieMinInt: 0,
      pieMaxInt: 100,
      precioMin: 0,
      precioMax: 100,
      prodTipoNegocio: undefined,
      isHomologated: false,
      homologatedCarsList: step1.homologatedCarsList || [],
      homologatedBrand: step1.homologatedBrand || null,
      homologatedModel: step1.homologatedModel || null,
      idExterno: params.get("idExterno") || "",
      brandExists: Boolean(params.get("brand")),
      modelExists: Boolean(params.get("model")),
      hgtedModelNotFound: false,
      hgtedBrandNotFound: false,
      cesId: "",
      cesIntegrationId: 0,
      cesCode: 0,
      injectRequest: true,
      idRegister: params.get("idRegister") || "",
      isQr: params.get("isQr") === 'true',
      vfmg: 0,
      carProducts: [],
      motoProducts: [],
      disablePrice: false,
      insurances: initialInsurances,
      isChinese: false,
      chineseProduct: { autorenuevate: null, autoplan: null },
    };

    if(params.get("cmp")) {
      defaultState.cmp = params.get("cmp");
    }

    if(defaultState.vehicleStatus == 1 && vehicleDetails.year === '') {
      vehicleDetails.year = this.calculateCurrentYear(vehicleDetails.vehicleType);
    }

    this.state = {
      ...defaultState,
      ...vehicleDetails,
      ...insuranceDetails,
    };

    if(vehicleDetails.brand) {
      this.props.getModelByVehicleType(vehicleDetails.vehicleType, vehicleDetails.brand);
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  cancellationRef = React.createRef();

  componentDidMount() {
    this.cancellationRef.current = false;
    // Initialize data if QR is enabled
    const promise = this.state.isQr ? this.initializeFromQR() : Promise.resolve();
    promise
      // Parse and set integration details
      .then(() => this.setIntegrationDetails())
      // Fetch necessary data
      .then(() => this.fetchInitialData())
      .catch((error) => console.error('Error in componentDidMount:', error))
  };

// Helper method to initialize data from QR
  initializeFromQR = async () => {
    try {
      await this.fromQR();
    } catch (error) {
      console.error('Error initializing from QR:', error);
    }
  };

// Helper method to parse and set integration details
  setIntegrationDetails = () => {
    const indexOfIntegration = this.props.match.params.id.indexOf('I');
    const integrationId = indexOfIntegration === -1
        ? 0
        : parseInt(this.props.match.params.id.substring(indexOfIntegration + 1));

    this.setState({
      cesId: this.props.match.params.id,
      cesIntegrationId: integrationId,
      disablePrice: some(CES_CONSIDERED, (e) => e === this.props.match.params.id),
    });
  };

// Helper method to fetch initial data
  fetchInitialData = async () => {
    try {
      await this.getCes();
      await this.getListaMarcas();
    } catch (error) {
      console.error('Error fetching initial data:', error);
    }
  };

  componentWillUnmount() {
    this.cancellationRef.current = true;
  }

  getCes = async () => {
    await this.props.getCesByCodSpider(this.props.match.params.id, (res) => {
      this.bringCes(res);
    });
    if (this.cancellationRef.current) return;
  }

  fromQR = async () => {
    await this.props.getRegistration(this.state.idRegister, (res) => {
      this.setState({
        brandId: `${res.brandId}`,
        brand: `${res.brandId}`,
        brandExists: true,
        model: res.modelId,
        modelId: res.modelId,
        modelExists: true,
        year: res.year,
        yearExists: true,
        price: res.price,
        priceClean: res.price,
        footClean: Math.trunc(res.price * 0.2),
        foot: Math.trunc(res.price * 0.2),
        priceExists: true,
        isDealrs: true,
        vehicleStatus: `${res.vehicleStatus}`,
        businessType: res.businessType,
        isMoto: res?.isMoto || false,
        vehicleType: res?.vehicleType || VEHICLE_TYPES.AUTO,
      });
      this.props.getMarcasByVehicleType(res?.vehicleType || VEHICLE_TYPES.AUTO);
      this.props.getModelByVehicleType(
          res?.vehicleType || VEHICLE_TYPES.AUTO,
          `${res.brandId}`
      );
      if (this.cancellationRef.current) return;
    });
  };

  bringCes = async (res) => {
    if (res.CONFIGURACION) {
      const carProducts = res?.VEHICULOS?.AUTO?.NEGOCIOS || [];
      const motoProducts = res?.VEHICULOS?.MOTO?.NEGOCIOS || [];

      this.validateBusiness(carProducts);

      this.setState({
        isHomologated: res?.HOMOLOGADO?.homologation,
        injectRequest: res.OTHERS.injectRequest,
        carProducts,
        motoProducts,
      });
      await this.setHomologatedData(res);
      if (this.state.isQr) {
        this.setState({isHomologated: false})
      }
    } else {
      console.log("Concesionario no encontrado");
    }
  };

  validateBusiness = (carProducts) => {
    if (carProducts.length === 1) {
      const productExists = find(
          carProducts,
          (e) => `${e.CodTipoNegocio}` === `${this.state.businessType}`
      );
      !productExists &&
      this.setState({ businessType: carProducts[0].CodTipoNegocio });
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.dataCes !== this.props.dataCes ||
        nextProps.registration !== this.props.registration ||
        nextProps.businessType !== this.state.businessType ||
        (nextProps.modelos !== this.props.modelos && this.props.modelos.length == 0) ||
        nextProps.cuota !== this.props.cuota ||
        (nextState.listMarcas !== this.state.listMarcas && this.state.listMarcas.length == 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modelos !== this.props.modelos) {
      if (!Object.keys(this.props.modelos).length == 0) {
        this.setState({ listModelos: this.props.modelos });
      }
    }

    if (prevProps.cuota !== this.props.cuota) {
      this.setState({
        shareValue: this.props.cuota.body.CuotaTrinidad.ValorCuota,
        valorCae: this.props.cuota.body.CuotaTrinidad.ValorCae,
        mensajeFechaError: "",
        flagCalculate: true,
        messageFoot: "",
        messagePrice: "",
        mensajeErrorService: this.props.cuota.body.CuotaTrinidad.Mensaje,
        loadingCalculo: false,
      });
    }
  };

  getListaMarcas = async () => {
    if(this.state.isHomologated) {
      await this.getHomologatedBrand(this.state.cesCode, this.state.brand, this.state.cesIntegrationId);
    }
    const idBrand = this.state.isHomologated && this.state.homologatedBrand
        ? this.state.homologatedBrand.brandId
        : params.get("brand");
    await this.props.getMarcasByVehicleType(
        this.state.vehicleType,
        async (allBrands) => {
          if (params.get("brand")) {
            await this.props.getModelByVehicleType(
                this.state.vehicleType,
                idBrand
            );
          }
          this.getProduct(allBrands, idBrand);
          if (Object.keys(allBrands).length > 0) {
            this.setState({ listMarcas: allBrands });
          }
        }
    );
  }

  getProduct = (allBrands = [], brand = "") => {
    if (!this.props.dataCes) return;

    const { dataCes } = this.props;
    const { businessType, priceClean, vehicleType, isMoto } = this.state;

    if (!businessType) return;

    let businessTypeInt = parseInt(businessType);
    let productoSelected = null;
    let dataProducto = null;
    let minpie = 0;
    let maxpie = 100;

    // Handle different vehicle types
    switch (true) {
      case parseInt(vehicleType) === VEHICLE_TYPES_INT.MOTO || isMoto: {
        const result = this.getProductByVehicleType(
            VEHICLE_TYPES.MOTO,
            dataProducto,
            dataCes,
            businessTypeInt,
            productoSelected,
            brand,
            minpie,
            maxpie
        );
        ({ dataProducto, productoSelected, minpie, maxpie } = result);
        break;
      }
      case parseInt(vehicleType) === VEHICLE_TYPES_INT.CAMION: {
        const result = this.getProductByVehicleType(
            VEHICLE_TYPES.CAMION,
            dataProducto,
            dataCes,
            businessTypeInt,
            productoSelected,
            brand,
            minpie,
            maxpie
        );
        ({ dataProducto, productoSelected, minpie, maxpie } = result);
        break;
      }
      case parseInt(vehicleType) === VEHICLE_TYPES_INT.BUS: {
        const result = this.getProductByVehicleType(
            VEHICLE_TYPES.BUS,
            dataProducto,
            dataCes,
            businessTypeInt,
            productoSelected,
            brand,
            minpie,
            maxpie
        );
        ({ dataProducto, productoSelected, minpie, maxpie } = result);
        break;
      }
      default: {
        dataProducto = findProductByBusinessType(dataCes, VEHICLE_TYPES.AUTO, businessTypeInt);

        const autoProducts = this.handleAutoProducts(
            dataProducto,
            businessTypeInt,
            allBrands,
            brand,
            priceClean
        );

        productoSelected = autoProducts.productoSelected;
        this.updateVehicleTypeAndModels(productoSelected, brand, this, this.props);

        const pieResult = this.setPie(minpie, productoSelected, maxpie);
        minpie = pieResult.minpie;
        maxpie = pieResult.maxpie;

        this.setState({ chineseProduct: { autorenuevate: autoProducts.autorenuevate, autoplan: autoProducts.autoplan } });
        break;
      }
    }

    // Update state with product data
    this.setState({
      productoSelected,
      dataProducto,
      foot: minpie,
      footClean: minpie,
      pieMinInt: minpie,
      pieMaxInt: maxpie,
      dataCes,
      vfmg: 0,
    });

    this.setProductState(productoSelected, this);

    // Auto-submit if all params are present
    if (
        params.get("businessType") &&
        params.get("vehicleStatus") &&
        params.get("brand") &&
        params.get("model") &&
        params.get("year") &&
        params.get("price")
    ) {
      setTimeout(() => {
        this.handleSubmit();
      }, 500);
    }
  };

  handleAutoProducts = (dataProducto, businessType, allBrands, brand, priceClean) => {
    const vehicleStatusSTRING = getVehicleStatusString(this.state.vehicleStatus);
    let productoSelected = null;
    let autorenuevate = null;
    let autoplan = null;

    if (businessType === 1) { // autorenuevate
      const __ret = this.handleAutoRenuevate(autorenuevate, dataProducto, vehicleStatusSTRING, allBrands, brand, priceClean, productoSelected);
      autorenuevate = __ret.autorenuevate;
      productoSelected = __ret.productoSelected;
    } else { // convencional
      const __ret = this.handleConvencional(autoplan, dataProducto, vehicleStatusSTRING, allBrands, brand, priceClean, productoSelected);
      autoplan = __ret.autoplan;
      productoSelected = __ret.productoSelected;
    }

    return { productoSelected, autorenuevate, autoplan };
  };

  handleConvencional(autoplan, dataProducto, vehicleStatusSTRING, allBrands, brand, priceClean, productoSelected) {
    const foundAutoplan = find(
        dataProducto?.PRODUCTOS,
        (prod) => prod.EsChino && prod.EstadoVehiculo === vehicleStatusSTRING
    );

    if (
        foundAutoplan &&
        currentChinese(allBrands, brand) &&
        valueIsBetween(
            foundAutoplan.PRECIOVENTA.Maximo,
            foundAutoplan.PRECIOVENTA.Minimo,
            priceClean
        )
    ) {
      productoSelected = foundAutoplan;
    } else {
      productoSelected = find(
          dataProducto?.PRODUCTOS,
          (prod) => prod.EsDefault && prod.EstadoVehiculo === vehicleStatusSTRING
      );

      if (!productoSelected) {
        productoSelected = dataProducto?.PRODUCTOS[0];
      }
    }

    return { autoplan: foundAutoplan, productoSelected };
  }

  handleAutoRenuevate(autorenuevate, dataProducto, vehicleStatusSTRING, allBrands, brand, priceClean, productoSelected) {
    const foundAutorenuevate = find(
        dataProducto?.PRODUCTOS,
        (prod) => prod.EsChino && prod.EstadoVehiculo === vehicleStatusSTRING
    );

    if (
        foundAutorenuevate &&
        currentChinese(allBrands, brand) &&
        valueIsBetween(
            foundAutorenuevate.PRECIOVENTA.Maximo,
            foundAutorenuevate.PRECIOVENTA.Minimo,
            priceClean
        )
    ) {
      productoSelected = foundAutorenuevate;
    } else {
      const carsProducts = filter(
          dataProducto?.PRODUCTOS,
          (prod) => prod.EstadoVehiculo === vehicleStatusSTRING
      );

      if (!this.state.price) {
        productoSelected = carsProducts[carsProducts.length - 1];
        this.setState({
          price: productoSelected.PRECIOVENTA.Minimo,
          priceClean: productoSelected.PRECIOVENTA.Minimo,
        });
      } else {
        productoSelected = find(carsProducts, (e) =>
            valueIsBetween(
                e.PRECIOVENTA.Maximo,
                e.PRECIOVENTA.Minimo,
                priceClean
            )
        );
      }
    }

    return { autorenuevate: foundAutorenuevate, productoSelected };
  }

  updateVehicleTypeAndModels = (productoSelected, brand, state, props) => {
    if (!params.get("isQr")) {
      props.getMarcasByVehicleType(
          productoSelected?.TipoVehiculo?.code || VEHICLE_TYPES_INT.AUTO
      );

      brand &&
      props.getModelByVehicleType(
          productoSelected?.TipoVehiculo?.code || VEHICLE_TYPES_INT.AUTO,
          state.brandId || brand
      );

      state.setState({
        vehicleType: productoSelected?.TipoVehiculo?.code || VEHICLE_TYPES_INT.AUTO,
      });
    }
  };

  setProductState = (productoSelected, state) => {
    if (!productoSelected) return;

    state.setState({
      precioMin: Math.min(productoSelected.PRECIOVENTA.Minimo, productoSelected.PRECIOVENTA.Maximo),
      precioMax: Math.max(productoSelected.PRECIOVENTA.Maximo, productoSelected.PRECIOVENTA.Minimo),
      pieMinPorcent: productoSelected.PIE.Minimo,
      pieMaxPorcent: productoSelected.PIE.Maximo,
      listPlazos: productoSelected.CUOTAS,
      term: productoSelected.CUOTAS[productoSelected.CUOTAS.length - 1].Plazo,
      vfmg: productoSelected.CUOTAS[productoSelected.CUOTAS.length - 1]?.RANGOVFMG?.Minimo || 0,
    });
  };

  getProductByVehicleType(vehicleType, dataProducto, dataCes, businessType, productoSelected, brand, minpie, maxpie) {
    let defaultVehicleType = VEHICLE_TYPES_INT.AUTO;
    const __ret = this.getDataProductByVehicleType(vehicleType, dataProducto, dataCes, businessType, defaultVehicleType);
    // Por defecto es auto, revisar si entra en moto, camion o bus
    if (__ret) {
      dataProducto = __ret.dataProducto;
      defaultVehicleType = __ret.defaultVehicleType;
    }

    if (dataProducto?.PRODUCTOS.length > 0 && !this.state.priceClean) {
      productoSelected = dataProducto.PRODUCTOS[0];
      this.setState({
        priceClean: productoSelected.PRECIOVENTA.Minimo,
        footClean: parseInt(
            (productoSelected.PIE.Minimo *
                productoSelected.PRECIOVENTA.Minimo) /
            100
        ),
      });
    } else {
      productoSelected = find(dataProducto?.PRODUCTOS, (e) =>
          valueIsBetween(
              e.PRECIOVENTA.Maximo,
              e.PRECIOVENTA.Minimo,
              this.state.priceClean
          )
      );
    }

    if (!params.get("isQr")) {
      this.props.getMarcasByVehicleType(
          productoSelected.TipoVehiculo?.code || defaultVehicleType
      );
      brand &&
      this.props.getModelByVehicleType(
          productoSelected.TipoVehiculo?.code || defaultVehicleType,
          brand || this.state.brandId
      );
      this.setState({
        vehicleType: productoSelected.TipoVehiculo?.code || defaultVehicleType,
      });
    }
    const __pie = this.setPie(minpie, productoSelected, maxpie);
    minpie = __pie.minpie;
    maxpie = __pie.maxpie;
    return { dataProducto, productoSelected, minpie, maxpie };
  }

  setPie(minpie, productoSelected, maxpie) {
    if (this.state.priceClean) {
      minpie = parseInt(
          (this.state.priceClean * productoSelected.PIE.Minimo) / 100
      );
      maxpie = parseInt(
          (this.state.priceClean * productoSelected.PIE.Maximo) / 100
      );
    } else {
      minpie = parseInt(
          (productoSelected.PRECIOVENTA.Minimo *
              productoSelected.PIE.Minimo) /
          100
      );
      maxpie = parseInt(
          (productoSelected.PRECIOVENTA.Minimo *
              productoSelected.PIE.Maximo) /
          100
      );
      this.setState({
        price: productoSelected.PRECIOVENTA.Minimo,
        priceClean: productoSelected.PRECIOVENTA.Minimo,
      });
    }
    return {minpie, maxpie};
  }

  getDataProductByVehicleType(vehicleType, dataProducto, dataCes, businessType, defaultVehicleType) {
    // MOTO
    if (vehicleType === VEHICLE_TYPES.MOTO) {
      dataProducto = find(
          dataCes?.VEHICULOS?.MOTO?.NEGOCIOS,
          (e) => e.CodTipoNegocio === businessType
      );
      defaultVehicleType = VEHICLE_TYPES_INT.MOTO;
    }
    // CAMION
    if (vehicleType === VEHICLE_TYPES.CAMION) {
      dataProducto = find(
          dataCes?.VEHICULOS?.CAMION?.NEGOCIOS,
          (e) => e.CodTipoNegocio === businessType
      );
      defaultVehicleType = VEHICLE_TYPES_INT.CAMION;
    }
    // BUS
    if (vehicleType === VEHICLE_TYPES.BUS) {
      dataProducto = find(
          dataCes?.VEHICULOS?.BUS?.NEGOCIOS,
          (e) => e.CodTipoNegocio === businessType
      );
      defaultVehicleType = VEHICLE_TYPES_INT.BUS;
    }
    return {dataProducto, defaultVehicleType};
  }

  setHomologatedData = async (ces) => {
    const { CONFIGURACION, HOMOLOGADO } = ces;
    const cesId = CONFIGURACION.codCes;
    const {
      isQr,
      brandExists,
      modelExists,
      modelId,
      brandId,
      cesIntegrationId,
      cesCode
    } = this.state;

    // Si no está homologado o es QR, verificamos condiciones especiales
    if (!(HOMOLOGADO?.homologation) || isQr === true) {
      this.homologationResetStates(brandExists, modelExists, HOMOLOGADO);
      return;
    }
    let cesCodeInt;
    if(!cesCode) {
      cesCodeInt = parseInt(this.props.match.params.id.split("C")[1].split("S")[0]);
      this.setState({cesCode: cesCodeInt});
    }
    await this.props.getHomologation(cesCodeInt || cesCode, cesIntegrationId, 0);
    // Caso 1: Tenemos el modelo pero no la marca
    if (!brandExists && modelExists) {
      await this.props.getBrandByModel(modelId);

      if (this.props.brandByModel) {
        return this.getHomologatedCars(
            cesId,
            this.props.brandByModel.homologatedBrandId,
            modelId,
            cesIntegrationId
        );
      } else {
        return this.setState({ modelExists: false, brandExists: false });
      }
    }

    // Caso 2: Tenemos la marca pero no el modelo
    if (brandExists && !modelExists) {
      return this.getHomologatedBrand(cesId, brandId, cesIntegrationId);
    }

    // Caso 3: No tenemos ni marca ni modelo
    if (!brandExists && !modelExists) {
      return this.setState({ modelExists: false, brandExists: false });
    }

    // Caso 4: Tenemos tanto marca como modelo
    return this.getHomologatedCars(
        cesId,
        brandId,
        modelId,
        cesIntegrationId
    );
  };

  homologationResetStates(brandExists, modelExists, HOMOLOGADO) {
    // Condiciones donde debemos resetear los estados
    const shouldResetStates = (!brandExists && modelExists) || !(brandExists && modelExists);

    if (shouldResetStates) {
      this.setState({modelExists: false, brandExists: false});
    }
    if (!HOMOLOGADO?.homologation && params.get("brand") && !this.state.brandExists) {
      this.setState({brandExists: true});
    }
  }

  getHomologatedBrand = async (ces, brand, idIntegration) => {
    await this.props.getHomologated(ces, brand, idIntegration, (res) => {
      if (res.length > 0) {
        let homologatedData = res[0];
        this.setState({
          homologatedBrand: {
            brand: homologatedData.brandName,
            brandId: homologatedData.brandId,
            homologatedBrandId: homologatedData.homologatedBrandId,
            homologatedBrandName: homologatedData?.homologatedBrandName,
          },
          brandExists: true,
          brand: homologatedData.homologatedBrandId,
          homologatedCarsList: this.props.homologated,
          hgtedBrandNotFound: false,
        });
        this.getHomologatedModel(homologatedData);
      } else {
        this.setState({brandExists: false, hgtedBrandNotFound: true});
      }
    });
  };

  getHomologatedModel(homologatedData) {
    this.props.getModelByVehicleType(this.state.vehicleType, homologatedData.brandId, (resp) => {
      let homologatedModels = [];
      if (Object.keys(this.props.homologationData).length !== 0) {
        resp.forEach(element => {
          let model = this.props.homologationData.find(item => parseInt(item.brandId) === parseInt(homologatedData.brandId) && parseInt(item.modelId) === parseInt(element.VMoCodigoModelo));
          if (model) {
            homologatedModels.push(model)
          }
        })
        this.setState({homologatedCarsList: homologatedModels});
      }
    });
  }

  getHomologatedCars = async (ces, brand, model, idIntegration) => {
    await this.props.getHomologatedCars(ces, brand, model, idIntegration, (res) => {
      if (res.length > 0) {
        let homologatedData = res[0];
        this.setState({
          homologatedBrand: {
            brand: homologatedData.brandName,
            brandId: homologatedData.brandId,
            homologatedBrandId: homologatedData.homologatedBrandId,
            homologatedBrandName: homologatedData.homologatedBrandName,
          },
          homologatedModel: {
            model: homologatedData.modelName,
            modelId: homologatedData.modelId,
            homologatedModelId: homologatedData.homologatedModelId,
            homologatedModelName: homologatedData.homologatedModelName,
          },
          homologatedCarsList: res,
          brandExists: true,
          brand:
              this.props.brandByModel?.homologatedBrandId ||
              homologatedData.homologatedBrandId,
        });
      } else {
        this.getHomologatedBrand(ces, brand, idIntegration, (car) => {
          this.setState({
            homologatedBrand: {
              brand: car.brandName,
              brandId: car.brandId,
              homologatedBrandId: car.homologatedBrandId,
              homologatedBrandName: car.homologatedBrandName,
            },
            brandExists: true,
            brand: car.homologatedBrandId,
          });

        });
        if (this.props.homologated.length > 0) {
          this.setState({ modelExists: false, hgtedModelNotFound: true });
        } else {
          this.setState({
            modelExists: false,
            brandExists: false,
            homologated: false,
          });
        }
      }
    });
  };

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    this.calculateFee();
  }

  goToUserData = () => {
    localStorage.setItem("step1", JSON.stringify(this.state));
    this.props.history.push("/page/userdata" + this.state.search);
  };

  onChange = (key) => (event) => {
    const state = { ...this.state };
    let value = event.target.value;
    Object.assign(state, { [key]: value });
    if(key === 'model' && this.state.isHomologated) {
      Object.assign(state, { homologatedModelName: this.state.homologatedCarsList[value] });
    }
    this.setState(state);
    this.setState({ hgtedModelNotFound: false });
  };

  handleBusinessChange = (e) => {
    const businessType = e.target.value;
    this.setState({
      businessTypeName:
          businessType === BUSINESS_TYPES.CONVENCIONAL ? "Convencional" : "Auto Renuévate",
      businessType,
      flagCalculate: false,
      valorCae: 0,
      shareValue: 0,
    });
    this.getListaMarcas();
  };

  onChangePlazo = () => (event) => {
    let value = event.target.value;

    this.setState({
      term: value,
      valorCae: 0,
      shareValue: 0,
      flagCalculate: false,
    });
  };

  handleChangeVFMG = (vfmg) => {
    this.setState({
      vfmg,
      valorCae: 0,
      shareValue: 0,
      flagCalculate: false
    });
  };

  onChangePrice = () => (event) => {
    // const state = { ...this.state };
    let value = event.target.value;

    let valueClean = value.replace("$", "");
    valueClean = valueClean.split(".").join("");

    let pieMinInt = 0;
    let pieMaxInt = 100;

    pieMinInt = parseInt(
        (valueClean * this.state.productoSelected.PIE?.Minimo || 0) / 100
    );
    pieMaxInt = parseInt(
        (valueClean * this.state.productoSelected.PIE?.Maximo || 100) / 100
    );

    this.setState({
      price: value,
      priceClean: valueClean,
      pieMinInt: pieMinInt,
      pieMaxInt: pieMaxInt,
    });
  };

  onChangePriceRange = (value) => {
    let pieMinInt;
    let pieMaxInt;

    pieMinInt = parseInt(
        (value * this.state.productoSelected.PIE.Minimo) / 100
    );
    pieMaxInt = parseInt(
        (value * this.state.productoSelected.PIE.Maximo) / 100
    );

    if (this.state.pieMinInt > this.state.footClean) {
      this.setState(prevState =>({
        footClean: prevState.pieMinInt + 100,
        foot: prevState.pieMinInt + 100,
      }));
    }
    if (this.state.pieMinInt < this.state.footClean) {
      this.setState(prevState => ({
        footClean: prevState.pieMaxInt - 100,
        foot: prevState.pieMaxInt - 100,
      }));
    }

    this.setState({
      price: value,
      priceClean: value,
      pieMinInt: pieMinInt,
      pieMaxInt: pieMaxInt,
    });
  };

  onChangeFoot = (value) => {
    this.setState({
      foot: value,
      footClean: typeof value === 'string' ? value.replace(/[.$]/g, "") : value,
      valorCae: 0,
      shareValue: 0,
      flagCalculate: false,
    });
  };

  onChangeMarca = (event) => {
    let value = event.target.value;
    if(value) {
        let idBrand = this.state.isHomologated && this.state.homologatedBrand
            ? this.state.homologatedBrand.brandId
            : value;
        this.props.getModelByVehicleType(this.state.vehicleType, idBrand);
        this.setState({ hgtedBrandNotFound: false, brand: value });
        this.getProduct(this.props.marcas, value);
    } else {
        this.setState({ listModelos: []})
    }
    this.setState({
        hgtedBrandNotFound: false,
        brand: value,
        flagCalculate: false,
        model: null,
        valorCae: 0,
        shareValue: 0,
    });
  };

  onChangeModel = (event) => {
    const value = event.target.value;
    const updatedState = { model: value };

    if (this.state.isHomologated) {
      const homologatedModel = this.state.homologatedCarsList.find(
          (car) => car.modelId === parseInt(value)
      );

      if (homologatedModel) {
        updatedState.homologatedModel = {
          model: homologatedModel.modelName,
          modelId: homologatedModel.modelId,
          homologatedModelId: homologatedModel.homologatedModelId,
          homologatedModelName: homologatedModel.homologatedModelName,
        };
      }
    }

    this.setState({
      ...updatedState,
      hgtedModelNotFound: false, // Reset the "not found" flag
      flagCalculate: false,
      valorCae: 0,
      shareValue: 0,
    });
  };

  calculateFee = async () => {
    let { SEGUROS, SEGUROSMOTOS, SEGUROSCAMIONES, SEGUROSBUS } = this.state.dataCes;
    let insurances
    switch (parseInt(this.state.vehicleType)) {
      case VEHICLE_TYPES_INT.MOTO: insurances = SEGUROSMOTOS; break;
      case VEHICLE_TYPES_INT.CAMION: insurances = SEGUROSCAMIONES; break;
      case VEHICLE_TYPES_INT.BUS: insurances = SEGUROSBUS; break;
      default: insurances = SEGUROS; break;
    }
    this.setState({ insurances });

    let price = 0;
    let foot = 0;
    if (typeof this.state.price === "number") {
      price = parseInt(this.state.price);
    } else {
      price = this.state.price.replace("$", "");
      price = price.split(".").join("");
      price = parseInt(price);
    }

    if (typeof this.state.foot === "number") {
      foot = parseInt(this.state.foot);
    } else {
      foot = this.state.foot.replace("$", "");
      foot = foot.split(".").join("");
      foot = parseInt(foot);
    }

    const porcentaje = (foot / price) * 100;
    const intPorcentaje = Math.round(porcentaje);

    if (price < this.state.precioMin || price > this.state.precioMax) {
      this.setState(prevState => ({
        messagePrice: `El valor del vehículo no puede ser menor a ${numeral(
            prevState.precioMin
        )
            .format("0,0[,]0")
            .replace(/,/g, ".")} y mayor a ${numeral(prevState.precioMax)
            .format("0,0[,]0")
            .replace(/,/g, ".")}`,
      }));
      return;
    }
    if (
        intPorcentaje <= this.state.pieMaxPorcent &&
        intPorcentaje >= this.state.pieMinPorcent
    ) {
      let marca = "";
      for (const element of this.state.listMarcas) {
        if (
            element.VemCodigoMarca + "" ===
            this.state.brand + ""
        ) {
          marca = element.VeMNombre;
        }
      }
      let modelo = "";
      for (let i = 0; i < this.state.listModelos.length; i++) {
        if (
            this.state.listModelos[i].VMoCodigoModelo + "" ===
            this.state.model + ""
        ) {
          modelo = this.state.listModelos[i].VMoModelo;
        }
      }
      let montoVFMG = 0;
      const vfmg =
          parseInt(this.state.vfmg) > 0 ? parseInt(this.state.vfmg) / 100 : 0;
      let data = {};

      let feeData = {
        ConsultaCuotaReqRest: {
          Precio: price,
          MontoPie: foot ? foot : 1,
          Plazo: this.state.term,
          Producto: this.state.productoSelected.CodProducto,
          TipoCredito: this.state.dataProducto.CodTipoNegocio,
          Seguros: insurances,
          Marca:
              (this.state.isHomologated &&
                  this.state.homologatedBrand?.homologatedBrandName) ||
              !marca
                  ? this.state.homologatedBrand?.homologatedBrandName
                  : marca,
          Modelo:
              (this.state.isHomologated &&
                  this.state.homologatedModel?.homologatedModelName) ||
              !modelo
                  ? this.state.homologatedModel?.homologatedModelName
                  : modelo,
          Anno: this.state.year,
          Dealer: this.state.dataCes.CONFIGURACION.codCes,
          Sucursal: this.state.dataCes.CONFIGURACION.codSucursal,
          EstadoVehiculo: this.state.vehicleStatus === "1" ? "N" : "U",
        },
      };
      if (this.state.dataProducto.CodTipoNegocio === 1) {
        montoVFMG = price * vfmg;
        data = {
          ConsultaCuotaReqRest: {
            ...feeData.ConsultaCuotaReqRest,
            MontoVFMG: Math.round(montoVFMG),
          },
        };
      } else {
        data = feeData;
      }

      this.setState({
        loadingCalculo: true,
      });

      if (!this.state.modelExists) {
        this.setState(prevState => ({
          homologatedModel: {
            model: (prevState.isHomologated &&
                prevState.homologatedModel?.homologatedModelName) ||
            !modelo
                ? prevState.homologatedModel?.homologatedModelName
                : modelo,
            homologatedModelName: (prevState.isHomologated &&
                prevState.homologatedModel?.homologatedModelName) ||
            !modelo
                ? prevState.homologatedModel?.homologatedModelName
                : modelo,
          },
        }));
      }

      localStorage.setItem("calculateFeeRequest", JSON.stringify(data));
      this.props.calculateFee(data);
    } else {
      this.setState(prevState => ({
        messageFoot:
            "El pie no puede ser menor al " +
            prevState.pieMinPorcent +
            " % y mayor al " +
            prevState.pieMaxPorcent +
            "% del precio del vehículo.",
      }));
    }
  };

  calculateMaxYear = () => {
    const month = parseInt(moment().format("MM"));
    if (month >= 7 && this.state.vehicleStatus !== 2)
      return moment().add(1, "y").format("YYYY");
    return moment().format("YYYY");
  };

  calculateCurrentYear = (vehicleType) => {
      const month = parseInt(moment().format("MM"));
      if (month >= 7 && vehicleType == 1)
          return moment().add(1, "y").format("YYYY");
      return moment().format("YYYY");
  }

  render() {
    return (
        <Container>
          <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9,
              }}
          >
            <BeatLoader
                size={50}
                color={"#cfb023"}
                loading={this.props.loadingFee}
            />
          </div>

          <Row>
            <Col md={8} className="offset-md-2 ">
              <form onSubmit={this.handleSubmit} className="card-shadow p-4">
                <div>
                  <div className="title-page">Simula tu crédito</div>
                  <div className="line-h1 mb-4"></div>
                  <div className="sub-title-page mb-4">Datos del vehículo</div>
                </div>
                <Row className="sm-business-container">
                  <BusinessForm
                      handleBusinessChange={this.handleBusinessChange}
                      productoSelected={this.state.productoSelected}
                      businessTypeName={this.state.businessTypeName}
                      businessType={this.state.businessType}
                      carProducts={this.state.carProducts}
                      loading={this.props.loading}
                      isMoto={this.state.isMoto}
                      disabled={!!params.get("businessType")}
                  />
                </Row>
                <VehicleForm
                    brand={this.state.brand}
                    model={this.state.model}
                    year={this.state.year}
                    listMarcas={this.state.listMarcas}
                    listModelos={this.state.listModelos}
                    isHomologated={this.state.isHomologated}
                    homologatedBrand={this.state.homologatedBrand}
                    homologatedModel={this.state.homologatedModel}
                    homologatedCarsList={this.state.homologatedCarsList}
                    brandExists={this.state.brandExists}
                    modelExists={this.state.modelExists}
                    modelId={this.state.modelId}
                    hgtedBrandNotFound={this.state.hgtedBrandNotFound}
                    hgtedModelNotFound={this.state.hgtedModelNotFound}
                    onChangeMarca={this.onChangeMarca}
                    onChangeModel={this.onChangeModel}
                    onChangeYear={(e) => this.onChange('year')(e)}
                    calculateMaxYear={this.calculateMaxYear}
                />

                <PriceInput
                    price={this.state.price}
                    priceClean={this.state.priceClean}
                    precioMin={this.state.precioMin}
                    precioMax={this.state.precioMax}
                    disablePrice={this.state.disablePrice}
                    priceExists={this.state.priceExists}
                    loadingFee={this.props.loadingFee}
                    messagePrice={this.state.messagePrice}
                    onChangePrice={this.onChangePrice()}
                    onChangePriceRange={this.onChangePriceRange}
                />
                <div>
                  <div className="sub-title-page mb-4 mt-4">Calcular cuota</div>
                </div>

                <FootAndTermInput
                    // Foot/Down Payment Props
                    foot={this.state.foot}
                    footClean={this.state.footClean}
                    pieMinInt={this.state.pieMinInt}
                    pieMaxInt={this.state.pieMaxInt}
                    messageFoot={this.state.messageFoot}
                    loadingFee={this.props.loadingFee}
                    onChangeFoot={this.onChangeFoot}

                    // Term Selector Props
                    term={this.state.term}
                    listPlazos={this.state.listPlazos}
                    onChangePlazo={this.onChangePlazo()}

                    // VFMG Slider Props
                    showVFMG={true}
                    vfmg={this.state.vfmg}
                    handleChangeVFMG={this.handleChangeVFMG}
                    businessType={this.state.businessType}
                />

                <Row></Row>

                <Row>
                  <Col md={12}>
                    <div className="mt-4">
                      <label className="labe-simulation-home">Valor Cuota*</label>
                      <div className="labe-black-simulation-home">
                        <label className="fee-value">
                          {"$" +
                              numeral(this.state.shareValue)
                                  .format("0,0[,]0")
                                  .replace(/,/g, ".")}
                        </label>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="form-group mt-1">
                      <div
                          className="labe-simulation-home"
                          style={{ fontSize: "0.8rem" }}
                      >
                        CAE: {this.state.valorCae} %
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    {this.state.mensajeErrorService && this.state.valorCae === 0 && (
                        <div
                            className="mb-4"
                            style={{ color: "red", fontSize: "1rem" }}
                        >
                          {this.state.mensajeErrorService}
                        </div>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="note-page-simulation-home">
                      *Cuota referencial: La presente es una simulación no
                      vinculante sino meramente referencial, hasta que se haya
                      aprobado la evaluación de riesgo comercial.
                    </div>
                  </Col>
                </Row>

                <Row>
                  <div className="text-center w-100">
                    <button
                        type="submit"
                        className="btn button-back mt-4 mr-4"
                        disabled={this.props.loadingFee}
                    >
                      Calcular
                    </button>

                    {!this.state.flagCalculate && this.state.injectRequest && (
                        <button
                            type="submit"
                            className="btn button-next mt-4 disabled"
                            disabled={this.props.loadingFee}
                        >
                          Siguiente
                        </button>
                    )}

                    {this.state.flagCalculate && this.state.injectRequest && (
                        <button
                            onClick={this.goToUserData}
                            type="button"
                            className={`btn button-next mt-4`}
                            disabled={
                                (this.props.cuota.body &&
                                    this.props.cuota.body.CuotaTrinidad &&
                                    this.props.cuota.body.CuotaTrinidad.Error) ||
                                this.props.loadingFee
                            }
                        >
                          Siguiente
                        </button>
                    )}
                  </div>
                </Row>
              </form>
            </Col>
          </Row>
        </Container>
    );
  }
}

Home.propTypes = {
  getModelByVehicleType: PropTypes.func,
  getBrandByModel: PropTypes.func,
  getHomologated: PropTypes.func,
  getMarcasByVehicleType: PropTypes.func,
  homologated: PropTypes.array,
  brandByModel: PropTypes.shape({
    homologatedBrandId: PropTypes.number,
  }),
  getHomologation: PropTypes.func,
  homologationData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  dataCes: PropTypes.object,
  loadingFee: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  loading: state.spider.loading,
  loadingFee: state.spider.loadingFee,
  marcas: state.spider.marcas,
  modelos: state.spider.modelos,
  gastos: state.spider.gastos,
  plazos: state.spider.plazos,
  productos: state.spider.productos,
  cuota: state.spider.cuota,
  typeProducts: state.spider.typeProducts,
  tasaVFMG: state.spider.tasaVFMG,
  dataCes: state.spider.dataCes,
  homologationData: state.spider.homologationData,
  homologatedCars: state.spider.homologatedCars,
  homologated: state.spider.homologated,
  brandByModel: state.spider.brandByModel,
  registration: state.spider.registration,
});

const mapDispatchToProps = {
  getMarcasByVehicleType,
  getModelByVehicleType,
  getModelosById,
  getGastos,
  getPlazos,
  calculateFee,
  getTypeProducts,
  getTasaVFMG,
  getCesByCodSpider,
  getHomologation,
  getHomologatedCars,
  getBrandByModel,
  getHomologated,
  getRegistration,
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
